export default "__VITE_ASSET__CNZNp$O7__"